import React, { useState } from 'react';
import { Rotate } from '@yme/assets/icons';
import { AccordionItemContainer, ButtonStyled, ContentStyled, LayoutStyled, SVGIconToggle, TitleStyled, } from './styled';
export function AccordionItem({ children, title, isRightToLeft, isOpen, onClick, isContentStylesCustom, customClosedIcon, id, }) {
    const [isItemOpen, setIsItemOpen] = useState(isOpen);
    const clickHandler = () => {
        setIsItemOpen(!isItemOpen);
    };
    return (React.createElement(AccordionItemContainer, { id: id },
        React.createElement(LayoutStyled, null,
            React.createElement(ButtonStyled, { type: "button", isShowed: onClick ? isOpen : isItemOpen, onClick: onClick || clickHandler },
                React.createElement(TitleStyled, { isRightToLeft: isRightToLeft }, title),
                customClosedIcon && !isItemOpen ? customClosedIcon : React.createElement(SVGIconToggle, { type: Rotate }))),
        React.createElement(ContentStyled, { isShowed: onClick ? isOpen : isItemOpen, isContentStylesCustom: isContentStylesCustom }, children)));
}
AccordionItem.displayName = 'AccordionItem_Component';
